import { gql } from "urql";
export const GetPublicInviteLandingEntitiesQuery = gql `
    query GetPublicInviteLandingEntities($organizationId: String!) {
        conditions {
            conditionsList {
                value
                label
            }
        }
        therapyCategories {
            therapyCategoriesList(organizationId: $organizationId) {
                value
                label
            }
        }
    }
`;
export const GetPublicInsuranceEntitiesQuery = gql `
    query GetPublicInsuranceEntities($search: String) {
        insurances {
            insurancesList(search: $search) {
                value
                label
            }
        }
    }
`;
export const GetPublicTherapySubCategoryGroupsQuery = gql `
    query GetPublicTherapySubCategoryGroups($therapyCategoryIds: [String!]) {
        therapySubCategories {
            therapySubCategoryGroups(therapyCategoryIds: $therapyCategoryIds) {
                group
                items {
                    value
                    label
                }
            }
        }
    }
`;
